<template>
  <div>
    <div class="row"><h1>Настройки</h1></div>
    <div class="row mb-3">
      <button class="btn btn-primary col-2" @click="toggleAdding">
        Добавить пользователя
      </button>
    </div>
    <div class="row">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Логин</th>
            <th>Группы</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user) in users" :key="user.id">
            <td>{{ user.id }}</td>
            <td>
              {{ user.username }}
            </td>
            <td>{{ user.groups.map((group) => group.name).join(', ') }}</td>
            <td>
              <button
                class="trash-btn btn btn-warning mt-0 float-left"
                :data-user-id="user.id"
                @click="toggleEditing(user.id)"
              >
                <font-awesome-icon icon="edit" />
              </button>
              <button
                class="trash-btn btn btn-warning mt-0 float-left"
                :data-user-id="user.id"
                @click="deleteUser(user.id)"
              >
                <font-awesome-icon icon="trash" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <el-dialog
        :visible.sync="isAdding"
        append-to-body
        :show-close="false"
        @close="onAddUserDialogClose"
        title="Добавление пользователя<"
    >
      <template slot="default">
        <el-form :model="addUserForm" :rules="addUserFormRules" ref="AddUserForm">
          <el-form-item label="Логин" prop="username">
            <el-input v-model="addUserForm.username"></el-input>
          </el-form-item>
          <el-form-item label="Пароль" prop="password">
            <el-input v-model="addUserForm.password"></el-input>
          </el-form-item>
          <el-form-item label="Группы пользователя" prop="groups">
            <div>
              <el-select
                  multiple
                  v-model="addUserForm.groups"
              >
                <el-option
                    v-for="(group, index) in groups"
                    :key="index"
                    :label="group.name"
                    :value="group.name"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
      </template>
      <template slot="footer">
        <button class="btn" @click="addUser">Сохранить</button>
        <button class="btn" @click="closeAdding">Закрыть</button>
      </template>
    </el-dialog>

    <el-dialog
        :visible.sync="isEditing"
        append-to-body
        :show-close="false"
        @close="onEditUserDialogClose"
        title="Редактирование пользователя"
    >
      <template slot="default">
        <el-form :model="editUserForm" :rules="editUserFormRules" ref="EditUserForm">
          <el-form-item label="Логин" prop="username">
            <el-input v-model="editUserForm.username"></el-input>
          </el-form-item>
          <el-form-item label="Пароль" prop="password">
            <el-input v-model="editUserForm.password"></el-input>
          </el-form-item>
          <el-form-item label="Группы пользователя" prop="groups">
            <div>
              <el-select
                  multiple
                  v-model="editUserForm.groups"
              >
                <el-option
                  v-for="(group, index) in groups"
                  :key="index"
                  :label="group.name"
                  :value="group.name"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
      </template>
      <template slot="footer">
        <button class="btn" @click="updateUser">Сохранить</button>
        <button class="btn" @click="closeEditing">Закрыть</button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {actionTypes as userActions} from '@/store/modules/users'
import {actionTypes as groupActions} from '@/store/modules/groups'
import ModalWindow from '@/components/ModalWindow'

export default {
  components: {ModalWindow},
  data() {
    return {
      isAdding: false,
      isEditing: false,
      addUserForm: {
        username: '',
        password: '',
        groups: [],
      },
      editUserForm: {
        username: '',
        password: '',
        groups: [],
      },
      addUserFormRules: {
        username: [
          { required: true, message: 'Введите логин пользователя латиницей', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Введите пароль', trigger: 'blur' }
        ],
        groups: [
          { required: true, message: 'Выберите группы пользователя', trigger: 'blur' }
        ],
      },
      editUserFormRules: {
        username: [
          { required: true, message: 'Введите логин пользователя латиницей', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Введите пароль', trigger: 'blur' }
        ],
        groups: [
          { required: true, message: 'Выберите группы пользователя', trigger: 'blur' }
        ],
      },
    }
  },
  computed: {
    ...mapState({
      users: (state) => state.users.users,
      groups: (state) => state.groups.groups,
    }),
  },
  mounted() {
    this.$store.dispatch(userActions.loadUsers)
    this.$store.dispatch(groupActions.loadGroups)
  },
  methods: {
    toggleAdding() {
      this.isAdding = !this.isAdding
    },
    toggleEditing(userId) {
      this.editUserForm = {...this.users.find(
        (user) => user.id == userId
      )}
      this.editUserForm.groups = this.editUserForm.groups.map(group => group.name)
      this.isEditing = !this.isEditing
    },
    updateUser() {
      this.$refs.EditUserForm.validate(valid => {
        if(valid){
          this.$store
              .dispatch(userActions.updateUser, {user: this.editUserForm})
              .then(() => {
                this.isEditing = !this.isEditing
                this.$store.dispatch(userActions.loadUsers)
                this.$store.dispatch(groupActions.loadGroups)
              })
        } else {
          return false
        }
      })
    },
    addUser() {
      this.$refs.AddUserForm.validate(valid => {
        if(valid){
          this.$store
              .dispatch(userActions.addUser, {user: this.addUserForm})
              .then(() => {
                this.isAdding = !this.isAdding
                this.$store.dispatch(userActions.loadUsers)
                this.$store.dispatch(groupActions.loadGroups)
              })
        } else {
          return false
        }
      })
    },
    deleteUser(userId){
      let user = this.users.find(
        (user) => user.id == userId
      )
      this.$store.dispatch(userActions.deleteUser, {user})
    },
    onAddUserDialogClose(){
      this.$refs.AddUserForm.resetFields()
    },
    onEditUserDialogClose(){
      this.$refs.EditUserForm.resetFields()
    },
    closeAdding(){
      this.onAddUserDialogClose()
      this.isAdding = false
    },
    closeEditing(){
      this.onEditUserDialogClose()
      this.isEditing = false
    }
  },
}
</script>
